import React, { useRef } from "react";

const Loader = () => (
  <div
    className="spinner-border spinner-border-sm text-primary"
    role="status"
    style={{ width: "14px", height: "14px" }}
  />
);

const ImportTemplateButtons = ({
  onImport,
  onDownloadTemplate,
  importLoading = false,
  templateLoading = false,
  accept = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
  ImportIcon,
  DownloadIcon,
  importLabel = "Import",
  templateLabel = "Template",
}) => {
  const fileInputRef = useRef(null);

  return (
    <div className="d-flex gap-2">
      {/* Import */}
      <div
        className={`my-import d-flex align-items-center justify-content-center gap-2 ${
          importLoading ? "disabled" : ""
        }`}
        style={{
          height: "40px",
          cursor: importLoading ? "not-allowed" : "pointer",
          opacity: importLoading ? 0.7 : 1,
        }}
        onClick={() => !importLoading && fileInputRef.current?.click()}
      >
        {importLoading ? (
          <>
            <Loader />
            <span className="fs-12 fw-600">Importing...</span>
          </>
        ) : (
          <>
            <ImportIcon style={{ width: "16px", height: "16px" }} />
            <div className="fs-12 fw-600">{importLabel}</div>
          </>
        )}

        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          onChange={onImport}
          style={{ display: "none" }}
          disabled={importLoading}
        />
      </div>

      {/* Template */}
      <div
        className={`my-import d-flex align-items-center justify-content-center gap-2 ${
          templateLoading ? "disabled" : ""
        }`}
        style={{
          height: "40px",
          cursor: templateLoading ? "not-allowed" : "pointer",
          opacity: templateLoading ? 0.7 : 1,
        }}
        onClick={!templateLoading ? onDownloadTemplate : undefined}
      >
        {templateLoading ? (
          <>
            <Loader />
            <span className="fs-12 fw-600">Downloading...</span>
          </>
        ) : (
          <>
            <DownloadIcon style={{ width: "16px", height: "16px" }} />
            <div className="fs-12 fw-600">{templateLabel}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImportTemplateButtons;
